/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type WorkOrderAssigneeBackofficeUsersQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type WorkOrderAssigneeBackofficeUsersQuery = {
  __typename?: 'Query'
  backofficeUsers: Array<
    | {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      }
    | {
        __typename?: 'BackofficeUserLimited'
        id: string
        firstName: string
        lastName: string
      }
  > | null
}

export const WorkOrderAssigneeBackofficeUsersDocument = gql`
    query WorkOrderAssigneeBackofficeUsers {
  backofficeUsers {
    ... on BackofficeUser {
      id
      firstName
      lastName
    }
    ... on BackofficeUserLimited {
      id
      firstName
      lastName
    }
  }
}
    `

/**
 * __useWorkOrderAssigneeBackofficeUsersQuery__
 *
 * To run a query within a React component, call `useWorkOrderAssigneeBackofficeUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderAssigneeBackofficeUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderAssigneeBackofficeUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkOrderAssigneeBackofficeUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorkOrderAssigneeBackofficeUsersQuery,
    WorkOrderAssigneeBackofficeUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    WorkOrderAssigneeBackofficeUsersQuery,
    WorkOrderAssigneeBackofficeUsersQueryVariables
  >(WorkOrderAssigneeBackofficeUsersDocument, options)
}
export function useWorkOrderAssigneeBackofficeUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkOrderAssigneeBackofficeUsersQuery,
    WorkOrderAssigneeBackofficeUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    WorkOrderAssigneeBackofficeUsersQuery,
    WorkOrderAssigneeBackofficeUsersQueryVariables
  >(WorkOrderAssigneeBackofficeUsersDocument, options)
}
// @ts-ignore
export function useWorkOrderAssigneeBackofficeUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkOrderAssigneeBackofficeUsersQuery,
    WorkOrderAssigneeBackofficeUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderAssigneeBackofficeUsersQuery,
  WorkOrderAssigneeBackofficeUsersQueryVariables
>
export function useWorkOrderAssigneeBackofficeUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderAssigneeBackofficeUsersQuery,
        WorkOrderAssigneeBackofficeUsersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderAssigneeBackofficeUsersQuery | undefined,
  WorkOrderAssigneeBackofficeUsersQueryVariables
>
export function useWorkOrderAssigneeBackofficeUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderAssigneeBackofficeUsersQuery,
        WorkOrderAssigneeBackofficeUsersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    WorkOrderAssigneeBackofficeUsersQuery,
    WorkOrderAssigneeBackofficeUsersQueryVariables
  >(WorkOrderAssigneeBackofficeUsersDocument, options)
}
export type WorkOrderAssigneeBackofficeUsersQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneeBackofficeUsersQuery
>
export type WorkOrderAssigneeBackofficeUsersLazyQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneeBackofficeUsersLazyQuery
>
export type WorkOrderAssigneeBackofficeUsersSuspenseQueryHookResult =
  ReturnType<typeof useWorkOrderAssigneeBackofficeUsersSuspenseQuery>
export type WorkOrderAssigneeBackofficeUsersQueryResult = Apollo.QueryResult<
  WorkOrderAssigneeBackofficeUsersQuery,
  WorkOrderAssigneeBackofficeUsersQueryVariables
>
